import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "single-product__price-box-container" }
const _hoisted_2 = {
  key: 0,
  class: "single-product__price-box"
}
const _hoisted_3 = { class: "single-product__price--promotion q-fw-semibold q-my-2" }
const _hoisted_4 = { class: "single-product__price--old" }
const _hoisted_5 = { class: "single-product__price--old-text" }
const _hoisted_6 = { class: "single-product__price--old-value q-fw-semibold" }
const _hoisted_7 = {
  key: 0,
  class: "single-product__omnibus-price-note"
}
const _hoisted_8 = { class: "single-product__omnibus-price-label" }
const _hoisted_9 = { class: "single-product__omnibus-price-wrapper" }
const _hoisted_10 = { class: "single-product__omnibus-price" }
const _hoisted_11 = {
  key: 1,
  class: "single-product__price-box q-fw-semibold q-my-2"
}
const _hoisted_12 = { class: "single-product__price" }

import {inject, ref, watchEffect} from 'vue';
import {formatPrice, getRealPrice, parsePrice} from "@/core/utils";
import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from '@/core/types'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'AutocompletePriceBox',
  props: ['product'],
  setup(__props) {

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)

const props = __props;


const {removeDecimals, currency: currencyCode} = SmartSearchConfig.value.appConfiguration

let oldPriceValue = ref(props.product.old_price || props.product.sale_price)
let {price, oldPrice} = getRealPrice(parsePrice(props.product.price), parsePrice(oldPriceValue.value))
let omnibusPrice = parsePrice(props.product.omnibus_price)
let oldPriceIsDifferent = price !== oldPrice
let omnibusPriceIsDifferent = price !== omnibusPrice
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


watchEffect(() => {
  oldPriceValue = ref(props.product.old_price || props.product.sale_price)
  price = getRealPrice(parsePrice(props.product.price), parsePrice(oldPriceValue.value)).price
  oldPrice = getRealPrice(parsePrice(props.product.price), parsePrice(oldPriceValue.value)).oldPrice
  omnibusPrice = parsePrice(props.product.omnibus_price)
  oldPriceIsDifferent = price !== oldPrice
  omnibusPriceIsDifferent = price !== omnibusPrice
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(oldPrice) && _unref(oldPriceIsDifferent))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatPrice)(_unref(price), _unref(currencyCode), _unref(removeDecimals))), 1),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(SmartSearchTranslations).autocomplete.oldPriceText) + ": ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatPrice)(_unref(oldPrice), _unref(currencyCode), _unref(removeDecimals))), 1)
          ]),
          (_unref(omnibusPrice) && _unref(omnibusPriceIsDifferent))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_unref(SmartSearchTranslations).autocomplete.omnibusLowestPrice) + ": ", 1),
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatPrice)(_unref(omnibusPrice), _unref(currencyCode), _unref(removeDecimals))), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(formatPrice)(_unref(price), _unref(currencyCode), _unref(removeDecimals))), 1)
        ]))
  ]))
}
}

})